<template>
  <div>
    <div class="btn btn-primary mb-2 row" v-on:click="$emit('view-coupons')">
      <i class="fas fa-tags fa-rotate-90 fa-align-left fa-2x"></i>
      <div class="d-inline-block">{{ couponName }}</div>
    </div>
    <!-- TODO: Reinclude with other view functionality
    <h4>Customers Also Viewed:</h4>
    <other-views v-for="view in otherViews"
                 v-bind:key="view.id"
                 :businessName="view.businessName"
                 :rating="view.rating"
                 :profilePic="view.profilePic"
                 :services="view.services"
                 :businessId="view.businessId"></other-views>
    -->
  </div>
</template>

<script>
import otherViews from './OtherViews.vue'

export default {
  data () {
    return {
      otherViews: []
    }
  },
  props: {
    couponName: String
  },
  components: {
    otherViews
  }
}
</script>

<style scoped>
.fa-tags {
  color: var(--dark-color);
}
</style>



// WEBPACK FOOTER //
// src/components/business/rightSide/RightSide.vue